/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CreateLabelRequestLabel
 */
export interface CreateLabelRequestLabel {
  /**
   *
   * @type {string}
   * @memberof CreateLabelRequestLabel
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof CreateLabelRequestLabel
   */
  color: string
}

export function CreateLabelRequestLabelFromJSON(json: any): CreateLabelRequestLabel {
  return CreateLabelRequestLabelFromJSONTyped(json, false)
}

export function CreateLabelRequestLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLabelRequestLabel {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: json['name'],
    color: json['color']
  }
}

export function CreateLabelRequestLabelToJSON(value?: CreateLabelRequestLabel | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    color: value.color
  }
}
